import PrehledPlatbaApi from 'mc/lib/api/gen/pohledavky/PrehledPlatbaApi';
import {DetailActions} from 'mc/lib/detail';
import {SimpleListActions} from 'mc/lib/list';
import ZadostApi from '../api/ZadostApi';
import {storeFromArea} from "mc/lib/utils";

export const ZADOST_AREA = "zadost";
export const ZADOST_PLATBA_LIST_AREA = "zadostPlatbaList";

export function fetchZadostIfNeeded(id, force = false) {
    return DetailActions.fetchIfNeeded(ZADOST_AREA, id, () => ZadostApi.getById(id), force);
}

export function fetchZadostPlatbyIfNeeded(id, force = false) {
    return SimpleListActions.fetchIfNeeded(ZADOST_PLATBA_LIST_AREA, id, () => PrehledPlatbaApi.findPrehledPlatbyByPripad(id), force);
}

export function invalidateCurrentZadost() {
    return (dispatch, getState) => {
        const zadost = storeFromArea(getState(), ZADOST_AREA);
        if (zadost.data) {
            dispatch(invalidateZadost(zadost.data.id));
        }
    };
}

export function invalidateZadost(id) {
    return DetailActions.invalidate(ZADOST_AREA, id);
}
